import { PropsWithChildren, useCallback, useState } from 'react';

import type { WidthNames } from '@atlaskit/modal-dialog/types';

import { DataEventProps } from '@/libraries/wpl/foundations/src/data-event-props';

import { Link } from '../../link/src/link';

import { Modal } from './modal';

export interface ModalLinkProps extends PropsWithChildren {
	modalTitle?: string;
	modalCloseLabel?: string;
	ctaText: string;
	modalWidth?: WidthNames;
	modalLinkType?: 'modal' | 'video';
	modalDataEventProps?: DataEventProps;
}

export const ModalLink = ({
	modalTitle,
	modalCloseLabel,
	children,
	ctaText,
	modalWidth,
	modalLinkType = 'modal',
	modalDataEventProps,
}: ModalLinkProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const openModal = (e: { preventDefault: () => void }) => {
		e.preventDefault();
		setIsOpen(true);
	};
	const closeModal = useCallback(() => setIsOpen(false), []);

	return (
		<>
			{/* TODO: It's not ideal to use an anchor here due to the modal component
            being internal to the page, but we are compromising for now to achieve 
            the desired styling */}
			<Link
				onClick={openModal}
				aria-label={'modal-link'}
				text={ctaText}
				href="#modal-section"
				type={modalLinkType}
				dataEventProps={modalDataEventProps}
			/>
			<Modal
				closeModal={closeModal}
				closeLabel={modalCloseLabel}
				title={modalTitle}
				isOpen={isOpen}
				width={modalWidth}
			>
				{children}
			</Modal>
		</>
	);
};
